import React, { PureComponent } from 'react';
import { isNetplayPageActive } from 'react/netplay/netplayPageState';

export default class MatchHistoryTableLink extends PureComponent {
	render() {
		const { className, url, children } = this.props;
		return (
			<a className={`${className ? className : ''} attention_grabber`}
			   href={url}
			   target={isNetplayPageActive() ? '_blank' : undefined}
			>
				<span className='text'>
				{children}
				</span>
			</a>
		);
	}
}